import React from "react";
import { Outlet, useNavigate } from "react-router-dom";

const RollingSim = () => {
  const navigate = useNavigate();

  return (
    <div>
      <nav className="flex space-x-4 bg-gray-800 p-4 text-white">
        <button
          onClick={() => navigate("/rolling-simulator")}
          className="hover:text-yellow-300"
        >
          Rolling Simulator
        </button>
        <button
          onClick={() => navigate("/rolling-simulator/stats")}
          className="hover:text-yellow-300"
        >
          Stats
        </button>
      </nav>
      <Outlet />
    </div>
  );
};

export default RollingSim;
